import styled from "styled-components";
import { Button } from "../../../Components/Button";

export const CancelledPaymentWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  padding: 20px;
  gap: 20px;
`;

export const CancelledPaymentImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export const CancelledPaymentImage = styled.img`
  width: 450px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 300px;
  }
`;

export const CancelledPaymentTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const CancelledPaymentTitle = styled.span`
  font-size: ${(props) => props.theme.fontSizes.xxlarge};
  font-weight: 600;
`;

export const MikeText = styled.span`
  color: ${(props) => props.theme.colors.accent2};
  font-weight: 600;
`;

export const CancelledPaymentTextWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const CancelledPaymentText = styled.span`
  font-size: ${(props) => props.theme.fontSizes.medium};
  font-weight: 300;
  color: ${(props) => props.theme.colors.font.grey1};
  text-align: center;
  width: 450px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const ButtonStyle = styled(Button)`
  width: 400px;
`;
